/**
 * Bron-van-waarheid voor enum-statussen.
 * Drift-guards in constants.test.js bewaken sync met backend.
 */

export const WERKNEMER_STATUSES = [
  "aangemeld","baseline_voltooid","gepland","aangemeten","verzonden","geleverd",
  "week4_voltooid","week12_voltooid","afgerond","opgezegd","no_show",
];
export const WERKNEMER_STATUS_LABELS = {
  aangemeld: "Aangemeld", baseline_voltooid: "Baseline voltooid",
  gepland: "Gepland", aangemeten: "Aangemeten", verzonden: "Verzonden",
  geleverd: "Geleverd", week4_voltooid: "Week 4 voltooid",
  week12_voltooid: "Week 12 voltooid", afgerond: "Afgerond",
  opgezegd: "Opgezegd", no_show: "No-show",
};

export const BESTELLING_STATUSES = [
  "klaar_om_te_bestellen","besteld","binnengekomen","in_productie",
  "verzonden","geleverd","foutief","herbesteld",
];
/** Prefab = de standaardzool via de Duitse partner, custom = op maat via PLT. */
export const ZOOLSOORTEN = ["prefab","custom"];
export const ZOOLSOORT_LABELS = { prefab: "Prefab", custom: "Custom (PLT)" };
export const NOTIFICATIE_STATUSES = [
  "pending","sending","verzonden","geopend","gefaald","overgeslagen",
];

/** Backend PijnplekRequest.locatie enum (openapi.json verified). */
export const PIJN_LOCATIES = ["tenen","voorvoet","midvoet","achtervoet","enkel"];
export const PIJN_LOCATIE_LABELS = {
  tenen: "Tenen", voorvoet: "Voorvoet", midvoet: "Midvoet",
  achtervoet: "Achtervoet", enkel: "Enkel",
};

/** Backend PijnplekRequest.zijde enum (openapi.json verified). */
export const PIJN_ZIJDES = ["onder","boven","binnenkant","buitenkant","tussenin","rondom"];
export const PIJN_ZIJDE_LABELS = {
  onder: "Onder", boven: "Boven", binnenkant: "Binnenkant",
  buitenkant: "Buitenkant", tussenin: "Tussenin", rondom: "Rondom",
};

/** Backend UitvoeringResponse.status enum (openapi.json verified). */
export const UITVOERING_STATUSSEN = ["gepland","in_uitvoering","voltooid","no_show","verzet"];
export const UITVOERING_STATUS_LABELS = {
  gepland: "Gepland", in_uitvoering: "In uitvoering",
  voltooid: "Voltooid", no_show: "No-show", verzet: "Verzet",
};

/** Backend AanmeetdagResponse.status enum. */
export const AANMEETDAG_STATUSSEN = ["voorgesteld","bevestigd","geannuleerd","voltooid"];

/** Pijn-flag drempelwaarde (auto-flag bij pijncijfer ≥ FLAG). Sync met backend `add_pijnplek_with_flag` RPC. */
export const PIJN_FLAG_DREMPEL = 7;
